var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",on:{"click":_vm.clicked}},[_c('p',[_vm._v(_vm._s(_vm.buttonLabel.toUpperCase()))]),_vm._v(" "),_c('i',{staticClass:"fas fa-redo-alt",class:{ 'animated': _vm.animated }})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1990a534","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Refresh.vue
// module id = 133
// module chunks = 0